import { api } from './api'
import { 
  LoginResponse, 
  RegisterRequest, 
  User 
} from '../types/auth'

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    // El backend responde envuelto como { success, data }
    const response = await api.post<{ success: boolean; data: LoginResponse }>(
      '/auth/login',
      { email, password }
    )
    return response.data.data
  },

  async register(data: RegisterRequest): Promise<User> {
    const response = await api.post<User>('/auth/register', data)
    return response.data
  },

  async getCurrentUser(): Promise<User> {
    const response = await api.get<LoginResponse>('/auth/me')
    return response.data.user
  },

  async refreshToken(refreshToken: string): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/refresh', { refreshToken })
    return response.data
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout')
  },

  async getProfile(): Promise<User> {
    const DEBUG_LOGS = false
    if (DEBUG_LOGS) console.log('AuthService: Getting user profile...')
    try {
      const response = await api.get<{ success: boolean; data: User; timestamp?: string; path?: string }>(
        '/auth/profile'
      )
      if (DEBUG_LOGS) console.log('AuthService: Profile response:', response.data)
      // Desempaquetar el wrapper { success, data }
      return response.data.data
    } catch (error) {
      console.error('AuthService: Error getting profile:', error)
      throw error
    }
  },

  async forgotPassword(email: string): Promise<void> {
    await api.post('/auth/forgot-password', { email })
  },

  async resetPassword(token: string, newPassword: string): Promise<void> {
    await api.post('/auth/reset-password', { token, newPassword })
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post('/auth/change-password', { currentPassword, newPassword })
  }
}
